import React, { Component } from "react";
import CopyRight from "../CopyRight";
import "react-confirm-alert/src/react-confirm-alert.css";

export default class Content extends Component {
  render() {
    const { children } = this.props;
    return (
      <div className="dev-page-content">
        <div className="container">
          {children}
          <CopyRight />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/_components/Layout/Content/index.js